import React, {useState, useEffect} from 'react';
import {useParams, useNavigate} from 'react-router-dom';
import {withTranslation} from 'react-i18next';
import {Panel} from "primereact/panel";
import {Button} from "primereact/button";
import axios from "axios";
import Cookies from "js-cookie";
import moment from "moment";
import currencyFormatter from "currency-formatter";

import HelpComponent from "../HelpComponent";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {ConfirmDialog} from "primereact/confirmdialog";
import {Dialog} from "primereact/dialog";
import {InputText} from "primereact/inputtext";
import {InputNumber} from "primereact/inputnumber";
import {InputMask} from "primereact/inputmask";
import {Calendar} from "primereact/calendar";
import {Dropdown} from "primereact/dropdown";

const _FM_ServiceShowComponent = (props) => {

  const {t} = props;
  const navigate = useNavigate();
  const {id, action} = useParams();
  const [formData, setFormData] = useState({});
  const [CFormData, setCFormData] = useState({});
  const [CFields, setCFields] = useState([]);
  const [TTasks, setTTasks] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (formData._country_specifics) {
      let countryObjectName = "service_" + Object.keys(formData._country_specifics)[0].toLowerCase() + "s";
      if (formData[countryObjectName][0] && formData[countryObjectName][0].id) {
        axios({
          method: 'get',
          url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "service-"
            + Object.keys(formData._country_specifics)[0].toLowerCase() + "/" + formData[countryObjectName][0].id,
          params: {},
          headers: {
            'Authorization': 'Bearer ' + Cookies.get("userToken"),
            "Sys-name": Cookies.get("instanceId"),
            "Preferred-locale": Cookies.get("language")
          }
        })
          .then(response => {
            setCFormData(response.data.data);
            const transformedCountry = Object.keys(formData._country_specifics)[0]
              ? Object.keys(formData._country_specifics)[0].charAt(0).toUpperCase() + Object.keys(formData._country_specifics)[0].slice(1).toLowerCase() : "";
            axios({
              method: 'get',
              url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "info/Service" + transformedCountry,
              params: {},
              headers: {
                'Authorization': 'Bearer ' + Cookies.get("userToken"),
                "Sys-name": Cookies.get("instanceId"),
                "Preferred-locale": Cookies.get("language")
              }
            })
              .then(response => {
                setCFields(response.data.editable_fields);
              })
              .catch(error => {
                window.App.toastShow('error', t('error'), error.toString(), '', error.response);
              })
          })
          .catch(error => {
            window.App.toastShow('error', t('error'), error.toString(), '', error.response);
          })
      }
    }
  }, [formData._country_specifics])

  useEffect(() => {
    if (id) {
      setLoading(true)
      axios({
        method: 'get',
        url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "service/" + id,
        params: {},
        headers: {
          'Authorization': 'Bearer ' + Cookies.get("userToken"),
          "Sys-name": Cookies.get("instanceId"),
          "Preferred-locale": Cookies.get("language")
        }
      })
        .then(response => {
          setLoading(false)
          setFormData(response.data.data);
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
          setLoading(false)
        })
      axios({
        method: 'get',
        url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "timed-task?&search[entity_id][operator]=%3D&search[entity_id][value]=" + id,
        params: {},
        headers: {
          'Authorization': 'Bearer ' + Cookies.get("userToken"),
          "Sys-name": Cookies.get("instanceId"),
          "Preferred-locale": Cookies.get("language")
        }
      })
        .then(response => {
          setTTasks(response.data.data.items);
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
    }
  }, [])

  return (
    <>
      <div className={"p-grid p-mt-3"}>
        <div className={"p-col p-col-align-center"}>
          <h2 className={"p-m-0"}>
        {formData.name || t('service_show')}
          </h2>
        </div>
        <div className={"p-col p-text-right p-col-align-center"}>
          <Button type="button" aria-label={t('edit')}
                  icon={"pi pi-pencil"}
                  onClick={() => {
                    navigate('/service/update/' + id)
                  }}
                  className="p-button-warning p-ml-2">
          </Button>
          <Button type="button"
                  icon={"pi pi-times"}
                  onClick={() => {
                    navigate(-1)
                  }}
                  className="p-button-secondary close p-ml-2">
          </Button>
        </div>
      </div>
      <div className={"p-grid"}>
        <div className={"p-col"}>
          <small className={"p-text-uppercase"}>
            {t('created_at')}
          </small>
          <p className={"p-mt-0 p-mb-0 p-text-bold"}>
            {moment.utc(formData.created_at_snapshot).local().format(t('YYYY-MM-DD HH:mm:ss'))}
          </p>
        </div>
        <div className={"p-col"}>
          <small className={"p-text-uppercase"}>
            {t('updated_at')}
          </small>
          <p className={"p-mt-0 p-mb-0 p-text-bold"}>
            {moment.utc(formData.updated_at_snapshot).local().format(t('YYYY-MM-DD HH:mm:ss'))}
          </p>
        </div>
      </div>
      <Panel className={"p-mt-3"}>
        {/*<HelpComponent type={"site"} position={"IN_ACTIVE_BOX"}/>*/}
        <HelpComponent type={"show_box"}/>
        <div className={"p-grid"}>
          <div className={"p-col-12 p-lg-6"}>
            <div className="p-field p-fluid">
              <label htmlFor="accommodation">{t('accommodation')}</label>
              <span className="p-d-block p-text-bold">
                {formData?.accommodation?.name}
              </span>
            </div>
          </div>
          <div className={"p-col-12 p-lg-6"}>
            <div className="p-field p-fluid">
              <label htmlFor="available_for">{t('available_for')}</label>
              <span className="p-d-block p-text-bold">
                {t(formData?.available_for?.toLowerCase())}
              </span>
            </div>
          </div>
        </div>
        <div className={"p-grid"}>
          <div className={"p-col-12 p-lg-3"}>
            <div className="p-field p-fluid">
              <label htmlFor="net_amount">{t('net_amount')}</label>
              <span className="p-d-block p-text-bold">
                {currencyFormatter.format(
                  formData.net_amount, {
                    precision: t('currency_precision'),
                    symbol: t('currency_symbol'),
                    decimal: t('currency_decimal'),
                    thousand: t('currency_thousand'),
                  }
                )} {formData?.currency}
              </span>
            </div>
          </div>
          <div className={"p-col-12 p-lg-3"}>
            <div className="p-field p-fluid">
              <label htmlFor="vatgroup">{t('vatgroup')}</label>
              <span className="p-d-block p-text-bold">
                {formData?.vat_group?.vat_percent} %
              </span>
            </div>
          </div>
          <div className={"p-col-12 p-lg-3"}>
            <div className="p-field p-fluid">
              <label htmlFor="gross_amount">{t('gross_amount')}</label>
              <span className="p-d-block p-text-bold">
                {currencyFormatter.format(
                  formData.gross_amount, {
                    precision: t('currency_precision'),
                    symbol: t('currency_symbol'),
                    decimal: t('currency_decimal'),
                    thousand: t('currency_thousand'),
                  }
                )} {formData?.currency}
              </span>
            </div>
          </div>
          <div className={"p-col-12 p-lg-3"}>
            <div className="p-field p-fluid">
              <label htmlFor="unit">{t('unit')}</label>
              <span className="p-d-block p-text-bold">
                {formData?.unit}
              </span>
            </div>
          </div>
        </div>
      </Panel>
      {CFields && CFields[0] &&
        <>
          <Panel className={"p-mt-3"}>
            <h3 className={"p-mt-0"}>
              {Object.keys(formData._country_specifics)[0].toUpperCase()}
            </h3>
            <div className={"p-grid"}>
              {CFields.map((field, index) => {
                if (field.name && (typeof CFormData[field.name] === 'string' || typeof CFormData[field.name] === 'number')) {
                  return (
                    <div className={"p-col-12 p-lg-6"} key={index}>
                      <div className="p-field p-fluid">
                        <label htmlFor={field.name}>{t(field.name)}</label>
                        <span className="p-d-block p-text-bold">
                          {CFormData[field.name]}
                        </span>
                      </div>
                    </div>
                  )
                }
              })}
            </div>
          </Panel>
        </>
      }
      {TTasks && TTasks[0] &&
        <Panel className={"p-mt-3"}>
          <div className={"p-grid"}>
            <div className={"p-col-12 p-lg-4 p-col-align-center"}>
              <h3 className={"p-m-0"}>{t('timed_price_change_tasks')}</h3>
            </div>
            <div className={"p-col p-text-right p-col-align-center"}>

            </div>
          </div>
          <DataTable
            value={TTasks}
            size={"small"}
            loading={loading} lazy
            emptyMessage={t('empty_message')}
            autoLayout={true}
            responsiveLayout={window.App.state.responsiveLayout}
            breakpoint="1365px"
            stripedRows
            dataKey="id"
            selectionMode={"single"}
          >
            
            <Column field="net_amount" sortable header={t('net_amount')}
                    className={"p-text-right"}
                    body={(rowData) => {
                      return (
                        <>
                          {currencyFormatter.format(
                            rowData.net_amount, {
                              precision: t('currency_precision'),
                              symbol: t('currency_symbol'),
                              decimal: t('currency_decimal'),
                              thousand: t('currency_thousand'),
                            }
                          )}
                          &nbsp;{formData?.currency}
                        </>
                      )
                    }}></Column>
            <Column field="execute_at" sortable header={t('execute_at')}
                    body={(rowData) => {
                      if (rowData.execute_at !== null) {
                        return (
                          <span>{moment.utc(rowData.execute_at).local().format(t('YYYY-MM-DD HH:mm'))}</span>
                        )
                      }
                    }}
            ></Column>
            <Column field="created_at_snapshot" sortable header={t('created_at')}
                    body={(rowData) => {
                      if (rowData.created_at_snapshot !== null) {
                        return (
                          <span>{moment.utc(rowData.created_at_snapshot).local().format(t('YYYY-MM-DD HH:mm:ss'))}</span>
                        )
                      }
                    }}></Column>
            <Column field="updated_at_snapshot" sortable header={t('updated_at')}
                filterField={"updated_at"}
                sortField={"updated_at"}
                    body={(rowData) => {
                      if (rowData.updated_at_snapshot !== null) {
                        return (
                          <span>{moment.utc(rowData.updated_at_snapshot).local().format(t('YYYY-MM-DD HH:mm:ss'))}</span>
                        )
                      }
                    }}></Column>
          </DataTable>
        </Panel>
      }
    </>
  )
}
export default withTranslation('common')(_FM_ServiceShowComponent);
